import { useEffect, useState } from "react";
import { senderCities } from "../../data/static-data";
import SelectCity, { selectCityInputLanguages } from "../citySelect/SelectCity";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCountries } from "../citySelect/selectCitySlice";

const SelectSenderAndReceiverRegions = ({ state, setState, errors }) => {
    const {t} = useTranslation()

    const [receiverGeolocation, setReceiverGeolocation] = useState({
        country: "Россия",
        city: null,
        district: null,
        area: null,
    })
    const countries = useSelector(selectCountries);

    useEffect(() => {
        if (!receiverGeolocation?.country) return;
        
        if(
            receiverGeolocation.country === state["receiver-country"] &&
            receiverGeolocation.city === state["receiver-city"] &&
            receiverGeolocation.district === state["receiver-district"] &&
            receiverGeolocation.area === state["receiver-area"]
        ) return;


            let hasCities = false;

            const country = countries.find(
                (country) => country["ru-name"] === receiverGeolocation.country || 
                country["tr-name"] === receiverGeolocation.country
            );

            if (country) {
                hasCities = country["has-cities"];
            }
            setState(prev => ({
                ...prev,
                "receiver-country": receiverGeolocation.country,
                "receiver-city": receiverGeolocation.city,
                "receiver-district": receiverGeolocation.district,
                "receiver-area": receiverGeolocation.area,
                countryHasCities: hasCities,
            }));
    }, [countries, receiverGeolocation, setState, state])

    return (
        <div className="flex flex-col gap-4">
            <div className="grid grid-cols-12 items-end">
                <span className="col-span-4 text-left text-3xs xs:text-sm sm:text-sm font-extralight">
                    {t("calculator.sender_city.title")}
                </span>
                <select
                    className="p-2 col-span-8 bg-transparent color-gray-400 border-b border-b-gray-400 hover:border-b-gray-500 text-3xs xs:text-xs sm:text-sm font-light"
                    name=""
                    id=""
                    value={state["sender-city"]}
                    onChange={(e) =>
                        setState((prev) => ({
                            ...prev,
                            "sender-city": e.target.value,
                        }))
                    }
                >
                    {senderCities.map((option, index) => (
                        <option defaultValue={state["sender-city"] === option.value} key={index} value={option.value}>
                            {option.text}
                        </option>
                    ))}
                </select>
            </div>
            <div className="">
                <SelectCity
                    state={receiverGeolocation}
                    setState={setReceiverGeolocation}
                    selectClassName="p-2 col-span-8 bg-transparent color-gray-400 border-b border-b-gray-400 hover:border-b-gray-500 text-3xs xs:text-xs sm:text-sm font-light"
                    containerClassName="flex flex-col gap-2"
                    inputBlockClassNames="grid grid-cols-12 w-full items-end"
                    inputsClassNames="col-span-8 border-b border-b-gray-400 hover:border-b-gray-500 text-left p-2 focus:outline-none text-3xs xs:text-xs sm:text-sm font-light"
                    labelClassNames="col-span-4 text-left text-3xs xs:text-xs sm:text-sm font-extralight"
                    countryInputLabel={t("calculator.select_receiver_country")}
                    cityInputLabel={t("calculator.select_receiver_city")}
                    language={selectCityInputLanguages.TR}
                />
                {errors["receiver-city"] && (
                    <div className="grid grid-cols-12 w-full items-end">
                        <div className="col-span-4"></div>
                        <div className="col-span-8 text-left text-red-700 text-3xs xs:text-xs sm:text-sm font-light">
                            {t(errors["receiver-city"])}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectSenderAndReceiverRegions;
